<template>
  <shu-lan :product-mark="47" />
</template>

<script>
import ShuLan from "@/views/shuLan";

export default {
  name: "ChangGanNaoInfo",
  components: { ShuLan },
};
</script>
